import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonActionComponent } from "./sidebar-button-action.component";
import { AuthService } from "@ponder-core/auth/auth.service";

@Component({
    selector: "sidebar-logout",
    imports: [],
    templateUrl: "./sidebar-button-action.component.html"
})
export class SidebarLogoutButtonComponent extends SidebarButtonActionComponent {
    public constructor(private auth: AuthService) { 
        super("Log Out", SvgIcon.LogOut, false); 
    }

    public override onClick(): void {
        this.auth.logOutAsync().then(() => { });
    }
}